import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { colors } from 'settings/colors'
import { getExternalVendorIconItems } from 'utils/getExternalVendorIconItems'
import { EXTERNAL_VENDOR_ICON_GAP } from 'utils/getExternalVendorIconsWidth'

export const ExternalVendorIcons = ({
  externalVendorNames,
  size,
}: {
  externalVendorNames: SharedTypes.IrrigationScheduler.EIrrigationVendorName[]
  size: number
}) => {
  const iconItems = getExternalVendorIconItems(externalVendorNames)

  if (iconItems.length === 0) return null

  return (
    <span css={{ display: 'flex', flex: 'none', alignItems: 'center', gap: EXTERNAL_VENDOR_ICON_GAP }}>
      {iconItems.map(({ vendorName, Icon, label }) => (
        <span
          key={vendorName}
          role="img"
          aria-label={label}
          title={label}
          css={{ 'display': 'flex', '& svg': { width: size, height: size } }}
        >
          <Icon color={colors.midnight} />
        </span>
      ))}
    </span>
  )
}
